import React, {useEffect} from "react";
import {connect} from "react-redux";
import {InterviewTexasContainer} from "./InterviewTexasContainer";
import * as lookupActions from "../../../actions/lookupActions";
import {LoadingBar} from "../../../components/LoadingComponents/LoadingBar";
import {InterviewOkMedicareSavingsProgramContainer} from "./InterviewOKMedicareSavingsProgram";

const InterviewGovernment = ({encounterId, configuration, getProgramSections, ...props}) => {
    const initialValues = {};

    useEffect(() => {
        if (configuration.programSections?.government == null) {
            getProgramSections(encounterId);
        }
    }, []);

    console.debug({value: configuration.programSections?.government})

    return (
        <LoadingBar isLoading={configuration.programSections?.government == null}>
            <div className="wizard-page">
                <h2 className="title">Government</h2>
                {configuration.programSections?.government === "OK Medicare Savings Plan" &&
                    <InterviewOkMedicareSavingsProgramContainer {...props} />}
                {configuration.programSections?.government !== "OK Medicare Savings Plan" &&
                    <InterviewTexasContainer {...props} />}

            </div>
        </LoadingBar>
    );
};

export const InterviewGovernmentContainer = connect(
    (state, ownProps) => ({
        encounterId: ownProps?.match?.params?.encounterId,
        configuration: state.interviewLookups.data?.configuration,
    }),
    dispatch => ({
        getProgramSections: interviewId => dispatch(lookupActions.getProgramSections(interviewId)),
    })
)(InterviewGovernment);
